export default {
  methods: {
    getItemSubtotal (item) {
      let modifTotal = 0
      if (item.hasOwnProperty('modifiers')) {
        item['modifiers'].forEach(function (mod) {
          if (!mod.void_status) modifTotal += mod.price
        })
      }
      const itemSubtotal = item.quantity * (item.price - item.discount + modifTotal)
      return itemSubtotal
    },
    issetActiveModifiersInItem (item) {
      let status = false
      if (item.hasOwnProperty('modifiers')) {
        item['modifiers'].forEach(function (mod) {
          if (!mod.void_status) {
            status = true
            return status
          }
        })
      }

      return status
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/orderMixin.js